import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    categories:
        [
            {
                name: "steampunk",
                status: false,
                type: "steampunk"
            },
            {
                name: "3d-objects",
                status: false,
                type: "3d-objects"
            },
            {
                name: "pixel",
                status: false,
                type: "pixel"
            },
            {
                name: "watercolor",
                status: false,
                type: "watercolor-architecture"
            },
            {
                name: "future-architecture",
                status: false,
                type: "future-architecture"
            },
            {
                name: "fantasy-character",
                status: false,
                type: "fantasy-character"
            },
            {
                name: "Pixel",
                status: false,
                type: "pixel"
            },
            {
                name: "Logo",
                status: false,
                type: "logo"
            },
            {
                name: "Streampunk",
                status: false,
                type: "steampunk"
            },
            {
                name: "diffusion",
                status: false,
                type: "diffusion"
            },
            {
                name: "creature",
                status: false,
                type: "creature"
            },
            {
                name: "surreal",
                status: false,
                type: "surreal"
            },
            {
                name: "fantasy-character",
                status: false,
                type: "fantasy-character"
            },
            {
                name: "watercolor-architecture",
                status: false,
                type: "watercolor-architecture"
            },
            {
                name: "future-architecture",
                status: false,
                type: "future-architecture"
            },
            {
                name: "contemporary-architecture",
                status: false,
                type: "contemporary-architecture"
            },
            {
                name: "future",
                status: false,
                type: "future"
            },
            {
                name: "paper-art",
                status: false,
                type: "pop-art"
            },
            {
                name: "watercolor",
                status: false,
                type: "watercolor"
            },
            {
                name: "3d-character",
                status: false,
                type: "3d-character"
            },
            {
                name: "3d-origami",
                status: false,
                type: "3d-origami"
            },
            {
                name: "3d-object",
                status: false,
                type: "3d-objects"
            },
            {
                name: "impressionism",
                status: false,
                type: "impressionism"
            },
            {
                name: "abstract",
                status: false,
                type: "abstract"
            },
            {
                name: "renaissance",
                status: false,
                type: "renaissance"
            },
            {
                name: "old-drawing",
                status: false,
                type: "old-drawing"
            },
            {
                name: "anime-portrait",
                status: false,
                type: "anime-portrait"
            },
            {
                name: "cyberpunk",
                status: false,
                type: "cyberpunk"
            },
            {
                name: "fantasy-world",
                status: false,
                type: "fantasy-world"
            },
            {
                name: "dream",
                status: false,
                type: "dream"
            },
            {
                name: "colorizer",
                status: false,
                type: "colorizer"
            },


        ],

}



export const categories = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        updateCategory: (state, action) => {

            state.categories.map((data, index) => {
                if (index == action.payload)
                    data.status = true
                else
                    data.status = false

            })

        },


    },
})

export const { updateCategory } = categories.actions

export default categories.reducer